import { PureComponent } from "react";
import PropTypes from "prop-types";
import L from "leaflet";

class TileLayer extends PureComponent {
  constructor(props) {
    super(props);

    const {
      lMap,
      url,
      lControl,
      name,
      options,
      isBaseLayer,
      defaultActiveLayer
    } = props;

    if (!lMap) {
      return;
    }

    const layer = L.tileLayer(url, { ...options });

    if (isBaseLayer) {
      lControl.addBaseLayer(layer, name);
      if (defaultActiveLayer) {
        lMap.addLayer(layer);
      }
    } else {
      lControl.addOverlay(layer, name);
    }

    this.name = name;
    this.layer = layer;
  }

  render() {
    return null;
  }
}

TileLayer.propTypes = {
  url: PropTypes.string,
  options: PropTypes.object,
  name: PropTypes.string,
  lMap: PropTypes.object,
  lControl: PropTypes.object,
  isBaseLayer: PropTypes.bool,
  defaultActiveLayer: PropTypes.bool
};
export default TileLayer;
